import React from 'react';
import { Button } from '../ui/Button';
const FAQS = [{
  q: '¿Es material digital?',
  a: 'Sí. Acceso inmediato desde cualquier dispositivo.'
}, {
  q: '¿Funciona si mi bebé se despierta mucho?',
  a: 'Sí. Está pensado justamente para eso.'
}, {
  q: '¿Necesito dejarlo llorar?',
  a: 'No. En ningún momento.'
}, {
  q: '¿Es un método mágico?',
  a: 'No. Es un sistema realista y respetuoso.'
}];
export function FAQ() {
  return <section className="py-16 px-4 bg-white" data-id="element-26">
      <div className="max-w-3xl mx-auto" data-id="element-27">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-28">
          ❓ Preguntas frecuentes
        </h2>

        <div className="space-y-4 mb-16" data-id="element-29">
          {FAQS.map((faq, i) => <div key={i} className="bg-gray-50 rounded-lg p-6 border border-gray-200" data-id="element-30">
              <h3 className="font-bold text-lg text-gray-900 mb-2" data-id="element-31">{faq.q}</h3>
              <p className="text-gray-700" data-id="element-32">{faq.a}</p>
            </div>)}
        </div>

        <div className="text-center bg-blue-50 rounded-2xl p-8 md:p-12" data-id="element-33">
          <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-34">
            Dormir mejor también es una forma de amar
          </h3>
          <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto" data-id="element-35">
            No necesitás entrenar a tu bebé. Necesitás comprenderlo y
            acompañarlo.
          </p>

          <Button href="https://checkout.mediosdigitalespro.online/cart/42525422551111:1" size="xl" className="w-full md:w-auto shadow-xl" data-id="element-36">
            👉 Accedé ahora al MegaPack Dormir Mejor Desde el Amor
          </Button>

          <p className="mt-6 text-gray-500 font-medium" data-id="element-37">
            Porque descansar, también es cuidar el vínculo. 💛
          </p>
        </div>
      </div>
    </section>;
}